theme.headerSticky = (function () {
  function ScrollSticky() {
    const headerStickyWrapper = document.querySelector("header");
    const headerStickyTargetList = document.querySelectorAll(".header__sticky");

    if (headerStickyTargetList.length > 0) {
      let headerHeight = headerStickyWrapper.clientHeight;
      headerStickyTargetList.forEach((headerStickyTarget) => {
        window.addEventListener("scroll", function () {

          // MOBILE CHECK: <=991px par sticky skip
          if (window.innerWidth <= 991) {
            headerStickyTarget.classList.remove("sticky");
            return; // mobile par scroll ke liye sticky logic skip
          }

          let StickyTargetElement = TopOffset(headerStickyWrapper);
          let TargetElementTopOffset = StickyTargetElement.top;

          if (window.scrollY > TargetElementTopOffset) {
            headerStickyTarget.classList.add("sticky");
          } else {
            headerStickyTarget.classList.remove("sticky");
          }
        });
      });
    }
  }
  return ScrollSticky;
})();
